import { Link } from 'react-router-dom';
import { categories } from '@/mocks/games';

export default function CategorySection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            <a href="#game-categories">热门游戏分类</a>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大游戏品类，数百款精品游戏，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer hover:-translate-y-1"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-primary-600 group-hover:text-background-50 text-xl md:text-2xl transition-colors duration-300`}></i>
              </div>
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}